// extracted by mini-css-extract-plugin
export default {"Button":"button_Button__qagA2","Primary":"button_Primary__09Gjb","Accent":"button_Accent__N-LGG","Error":"button_Error__hWKU8"};